import { render } from "./ResultTableItemMobile.vue?vue&type=template&id=3225dfea&scoped=true"
import script from "./ResultTableItemMobile.vue?vue&type=script&lang=js"
export * from "./ResultTableItemMobile.vue?vue&type=script&lang=js"

import "./ResultTableItemMobile.vue?vue&type=style&index=0&id=3225dfea&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3225dfea"]])

export default __exports__